module.exports = __webpack_public_path__ + "img/weixin.b03136a4.png";